// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import { AccountsSettingsInfoRow } from '../AccountSettingsInfoRow/AccountsSettingsInfoRow'
import { AccountSettingsSection } from '../AccountSettingsSection/AccountSettingsSection'
import { SecuritySectionEditMode } from './SecuritySectionEditMode/SecuritySectionEditMode'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const SecuritySection = ({ isEditMode, toggleIsEditMode }) => {
  if (isEditMode) {
    return <SecuritySectionEditMode toggleIsEditMode={toggleIsEditMode} />
  }

  return (
    // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered
    <AccountSettingsSection title='Password' isWithEditBtn editModeBtnHandler={() => toggleIsEditMode(true)}>
      {/*
       // @ts-expect-error TS2741 -- MIGRATION: not approved, fix when encountered */}
      <AccountsSettingsInfoRow keyValue='Password:' value='**********' type='password' isTheLastItem />
    </AccountSettingsSection>
  )
}
